"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useNotification = require("./useNotification");
Object.keys(_useNotification).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useNotification[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useNotification[key];
    }
  });
});